import PropTypes from 'prop-types';
import React from 'react';

import t from '../../lib/I18n';
import { StationTypes } from '../../constants/AppConstants';

import AddStationButton from './AddStationButton';

export default function AddStation ({ activeAddButton, onSelect }) {
    return (
        <div className="stationFinder__modal-add-station">
            <div className="stationFinder__modal-text">
                { t('stationFinder.modal.mainText') }
            </div>
            <AddStationButton type={ StationTypes.ORIGIN }
                              activeAddButton={ activeAddButton }
                              onSelect={ onSelect }
            />
            <AddStationButton type={ StationTypes.DESTINATION }
                              activeAddButton={ activeAddButton }
                              onSelect={ onSelect }
            />
        </div>
    );
}

AddStation.propTypes = {
    activeAddButton: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    disableOrigin: PropTypes.bool,
    disableDestination: PropTypes.bool
};

AddStation.defaultProps = {
    activeAddButton: null,
    disableOrigin: false,
    disableDestination: false
};



// WEBPACK FOOTER //
// ./src/components/stationFinder/AddStation.js